<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-12">
    <div class="max-w-md w-full text-center">
      <p class="text-sm font-semibold text-indigo-600">404</p>
      <h1 class="mt-3 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
        Page not found
      </h1>
      <p class="mt-4 text-base text-gray-600">
        The page you're looking for doesn't exist or has been moved.
      </p>

      <div class="mt-8 flex flex-col sm:flex-row justify-center gap-3">
        <Button variant="primary" @click="goHome">Back to home</Button>
        <Button variant="outline" @click="goBack">Go back</Button>
      </div>

      <p v-if="requestedPath" class="mt-8 text-xs text-gray-500">
        Requested: <code class="font-mono">{{ requestedPath }}</code>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { Button } from '@asabdev/asab-ui';

  const route = useRoute();
  const router = useRouter();

  const requestedPath = computed(() => route.fullPath || '');

  function goHome() {
    router.push('/');
  }

  function goBack() {
    if (window.history.length > 1) {
      router.back();
    } else {
      router.push('/');
    }
  }
</script>
